<template>
<div class="row">
   <div class="provider col mm yo-hidden-phone  yo-align-right yo-text-bold">&#160;</div>
   <div class="provider col m2 yo-hidden-phone  yo-align-right yo-text-bold" >&#160;</div>
   <div class="provider col s12 m9m yo-align-right yo-text-bold"> provider {{evento.providernome}} n°{{evento.providernumero}}</div>
</div>
</template>

<script>
export default {
   props: {evento: Object,rowheight: Number}
}
</script>


// WEBPACK FOOTER //
// src/components/Evento-elenco-provider.vue